import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from "@angular/core";
import { TranslatePipe } from "@skylab-angular-shared/pipes";
import { ButtonComponent } from '@skylab-angular-shared/ui';

@Component({
    selector: 'skl-fiscal-daily-report-toast-component',
    template: `
        <div>{{text()}}</div>
        <ul>
            @for (message of messages(); track message) {
                <li>{{message}}</li>
            }
        </ul>
        <div>
            {{ 'scenes.shared.toast.fiscalization.daily-report.create' | translate}}
        </div>

        <div class="actions">
            <skl-button 
                (click)="handle()?.()"
                data-type="frame"
            >
                {{'scenes.shared.toast.fiscalization.daily-report.yes' | translate}}
            </skl-button>
            <skl-button 
                (click)="dismiss()?.()"
                data-type="frame"
            >
                {{'scenes.shared.toast.fiscalization.daily-report.no' | translate}}
            </skl-button>
        </div>
    `,
    styles: `
        :host {
            display: flex;
            flex-direction: column;
            gap: var(--gutter-small);
            font-size: .9rem;
            color: var(--text-minor-color);
        }

        .actions {
            display: flex;
            gap: var(--gutter-small);

            & > skl-button {
                flex: 1;
            }
        }
    `,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [TranslatePipe, ButtonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FiscalDailyReportToastComponent {
    public readonly handle = input<() => void>();
    public readonly dismiss = input<() => void>();
    public readonly text = input<string>();
    public readonly messages = input<string[]>();
}
